import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { io } from 'socket.io-client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

const queryClient = new QueryClient()
const socket = io(import.meta.env.VITE_BACKEND_ENDPOINT, {
  autoConnect: false,
  transports: ['websocket']
})

const container = document.getElementById('root')
if (!container) throw new Error('Root element not found')

createRoot(container).render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App socket={socket} />
    </QueryClientProvider>
  </React.StrictMode>
)
